<div class="dashboard-container">
  <app-dashboard-nav></app-dashboard-nav>
  <div class="dashboard-content">
    <router-outlet></router-outlet>
  </div>
</div>
